import React from 'react';
import { Box, Autocomplete, AutocompleteCloseReason } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { PopperComponent, StyledInput } from './StyledComponents';

interface AutocompleteComponentProps {
	pendingValue: any;
	setPendingValue: (newValue: any) => void;
	handleClose: () => void;
	options: any[];
	optionLabelAttribute: string;
	loadingOptions: boolean;
	theme: any;
}

const AutocompleteComponent = ({
	pendingValue,
	setPendingValue,
	handleClose,
	options,
	optionLabelAttribute,
	loadingOptions,
	theme,
}: AutocompleteComponentProps) => (
	<Autocomplete
		open
		onClose={(
			event: React.ChangeEvent<{}>,
			reason: AutocompleteCloseReason,
		) => {
			if (reason === 'escape') {
				handleClose();
			}
		}}
		loading={loadingOptions}
		value={pendingValue}
		onChange={(event, newValue, reason) => {
			if (
				event.type === 'keydown' &&
				((event as React.KeyboardEvent).key === 'Backspace' ||
					(event as React.KeyboardEvent).key === 'Delete') &&
				reason === 'removeOption'
			) {
				return;
			}
			setPendingValue(newValue);
		}}
		disableCloseOnSelect
		PopperComponent={PopperComponent}
		renderTags={() => null}
		noOptionsText="No labels"
		renderOption={(props, option, { selected }) => (
			<OptionItem
				props={props}
				optionName={option[optionLabelAttribute]}
				selected={selected}
				theme={theme}
				setPendingValueToNull={() => setPendingValue(null)}
			/>
		)}
		options={options}
		getOptionLabel={(option) => option[optionLabelAttribute]}
		renderInput={(params) => (
			<StyledInput
				ref={params.InputProps.ref}
				inputProps={params.inputProps}
				autoFocus
				placeholder="Filter"
			/>
		)}
	/>
);

interface OptionItemProps {
	props: any;
	optionName: string;
	selected: boolean;
	theme: any;
	setPendingValueToNull: () => void;
}

const OptionItem = ({
	props,
	optionName,
	selected,
	theme,
	setPendingValueToNull,
}: OptionItemProps) => (
	<li {...props}>
		<Box
			component={DoneIcon}
			sx={{
				width: 17,
				height: 17,
				mr: '5px',
				ml: '-2px',
				visibility: selected ? 'visible' : 'hidden',
			}}
		/>
		<Box
			sx={{
				flexGrow: 1,
				'& span': {
					color:
						theme.palette.mode === 'light' ? '#586069' : '#8b949e',
				},
			}}
		>
			{optionName}
		</Box>
		<Box
			component={CloseIcon}
			sx={{
				opacity: 0.6,
				width: 18,
				height: 18,
				visibility: selected ? 'visible' : 'hidden',
			}}
			onClick={setPendingValueToNull}
		/>
	</li>
);

export default AutocompleteComponent;
